/* ============================================================
   QUE PASA — Product section JS (Dawn)
   File: assets/section-quepasa-product.js
   Handles: size selection -> variant id, gallery thumb sync,
   ships-by date, community auto-slider. Scoped to .qp.
   ============================================================ */
(function () {
  function init(root) {
    if (!root || root.dataset.qpInit) return;
    root.dataset.qpInit = '1';

    /* ---- Size buttons -> hidden variant id ---- */
    var sizeBtns = root.querySelectorAll('.qp-size-btn');
    var variantInput = root.querySelector('.qp-variant-id');
    var sizeCurrent = root.querySelector('.qp-size-current');
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (sizeCurrent) sizeCurrent.textContent = btn.dataset.value || '';
        if (variantInput && btn.dataset.variantId) variantInput.value = btn.dataset.variantId;
      });
    });

    /* ---- Size guide pop-up ---- */
    var sgBtn = root.querySelector('[data-qp-sizeguide]');
    var sgModal = root.querySelector('[data-qp-sg-modal]');
    if (sgBtn && sgModal) {
      var sgClose = sgModal.querySelector('[data-qp-sg-close]');
      var openSG = function () { sgModal.hidden = false; document.body.style.overflow = 'hidden'; };
      var closeSG = function () { sgModal.hidden = true; document.body.style.overflow = ''; };
      sgBtn.addEventListener('click', openSG);
      if (sgClose) sgClose.addEventListener('click', closeSG);
      sgModal.addEventListener('click', function (e) { if (e.target === sgModal) closeSG(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sgModal.hidden) closeSG(); });
    }

    /* ---- Gallery: thumbnails <-> swipe carousel (mobile) ---- */
    var gallery = root.querySelector('.qp-gallery');
    var frames = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.qp-frame')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.qp-gthumb'));
    if (gallery && thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = +t.dataset.idx;
          var f = frames[i];
          if (f) gallery.scrollTo({ left: f.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        });
      });
      var raf = null;
      gallery.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var center = gallery.scrollLeft + gallery.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          frames.forEach(function (f, n) {
            var fc = f.offsetLeft - gallery.offsetLeft + f.clientWidth / 2;
            var d = Math.abs(fc - center);
            if (d < bestDist) { bestDist = d; best = n; }
          });
          thumbs.forEach(function (t, n) { t.classList.toggle('active', n === best); });
          if (thumbs[best]) thumbs[best].scrollIntoView({ inline: 'nearest', block: 'nearest' });
        });
      }, { passive: true });
    }

    /* ---- Ships-by date: next day (tomorrow) ---- */
    var ship = root.querySelector('.qp-ship-date');
    if (ship) {
      var d = new Date(); d.setDate(d.getDate() + 1);
      ship.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }

    /* ---- Community strip: coverflow, auto-advance every 2s on phones ---- */
    var strip = root.querySelector('.qp-strip');
    if (strip && !strip.dataset.qpAuto) {
      var isPhone = window.matchMedia && window.matchMedia('(max-width:560px)').matches;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var origCount = strip.children.length;
      if (isPhone && !reduce && origCount >= 2) {
        strip.dataset.qpAuto = '1';
        strip.classList.add('qp-live');
        for (var c = 0; c < 2; c++) {                 // 2 extra kopieën → altijd buurfoto links én rechts
          for (var i = 0; i < origCount; i++) { strip.appendChild(strip.children[i].cloneNode(true)); }
        }
        var baseIdx = origCount;                      // start op de middelste kopie
        var stepSize = function () { return strip.children[1].offsetLeft - strip.children[0].offsetLeft; };
        var centerOn = function (idx) { var el = strip.children[idx]; if (el) { strip.scrollLeft = el.offsetLeft + el.offsetWidth / 2 - strip.clientWidth / 2; } };
        var updateActive = function () {
          var mid = strip.scrollLeft + strip.clientWidth / 2, best = null, bestD = 1e9;
          for (var k = 0; k < strip.children.length; k++) {
            var el = strip.children[k], cc = el.offsetLeft + el.offsetWidth / 2, d = Math.abs(cc - mid);
            if (d < bestD) { bestD = d; best = el; }
          }
          for (var k = 0; k < strip.children.length; k++) { strip.children[k].classList.toggle('is-active', strip.children[k] === best); }
        };
        var raf;
        strip.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; updateActive(); }); }, { passive: true });
        requestAnimationFrame(function () { centerOn(baseIdx); updateActive(); });
        var paused = false, pauseTimeout = null;
        strip.addEventListener('touchstart', function () { paused = true; }, { passive: true });
        strip.addEventListener('touchend', function () {
          clearTimeout(pauseTimeout);
          pauseTimeout = setTimeout(function () { paused = false; }, 3000);
        }, { passive: true });
        setInterval(function () {
          if (paused) return;
          var setWidth = stepSize() * origCount;
          var base = strip.children[baseIdx].offsetLeft + strip.children[baseIdx].offsetWidth / 2 - strip.clientWidth / 2;
          if (strip.scrollLeft >= base + setWidth - 2) { strip.scrollLeft -= setWidth; }
          strip.scrollBy({ left: stepSize(), behavior: 'smooth' });
        }, 2000);
      }
    }
  }

  function boot() {
    document.querySelectorAll('.qp').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when the theme editor re-renders the section
  document.addEventListener('shopify:section:load', boot);
})();
